import React from 'react';
import { Phone, MoreHorizontal } from 'lucide-react';
import { ContactSettings } from '../types';

interface ContactCardProps {
  settings: ContactSettings;
}

const ContactCard: React.FC<ContactCardProps> = ({ settings }) => {
  // Use default true if visibility object is missing
  const visibility = settings.visibility || {
    facebook: true,
    messenger: true,
    viber: true,
    telegram: true,
    line: true,
    phone: true,
    more: true
  };

  return (
    <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700 p-6 mx-4 mb-24 transition-colors duration-300">
      <div className="flex items-center justify-center gap-3 mb-6">
        <span className="text-xl">🇹🇭</span>
        <h2 className="text-center font-bold text-gray-800 dark:text-gray-200 font-myanmar text-sm sm:text-base">ငွေလဲရန် ဆက်သွယ်စုံစမ်းရန်</h2>
        <span className="text-xl">🇲🇲</span>
      </div>

      {/* Row of Icons - Conditional Rendering */}
      <div className="flex justify-center gap-3 items-center px-2 mb-8 no-scrollbar overflow-x-auto whitespace-nowrap">
        {visibility.facebook && (
          <a href={settings.facebookUrl} target="_blank" rel="noreferrer" className="shrink-0 transition-transform active:scale-90">
            <img src="https://upload.wikimedia.org/wikipedia/commons/b/b8/2021_Facebook_icon.svg" alt="FB" className="w-8 h-8 rounded-full shadow-sm" />
          </a>
        )}
        {visibility.messenger && (
          <a href={settings.messengerUrl} target="_blank" rel="noreferrer" className="shrink-0 transition-transform active:scale-90">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Facebook_Messenger_logo_2020.svg/2048px-Facebook_Messenger_logo_2020.svg.png" alt="Msg" className="w-8 h-8" />
          </a>
        )}
        {visibility.viber && (
          <a href={settings.viberUrl} target="_blank" rel="noreferrer" className="shrink-0 transition-transform active:scale-90">
            <img src="https://static.vecteezy.com/system/resources/previews/018/930/719/non_2x/viber-logo-viber-icon-transparent-free-png.png" alt="Viber" className="w-8 h-8 shadow-sm" />
          </a>
        )}
        {visibility.telegram && (
          <a href={settings.telegramUrl} target="_blank" rel="noreferrer" className="shrink-0 transition-transform active:scale-90">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/1024px-Telegram_logo.svg.png" alt="TG" className="w-8 h-8" />
          </a>
        )}
        {visibility.line && (
          <a href={settings.lineUrl} target="_blank" rel="noreferrer" className="shrink-0 transition-transform active:scale-90">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/LINE_logo.svg/1024px-LINE_logo.svg.png" alt="Line" className="w-8 h-8" />
          </a>
        )}
      </div>

      {/* Action Buttons Row */}
      <div className="flex justify-center items-center gap-4">
        {visibility.phone && (
          <a 
            href={`tel:${settings.phoneNumber}`} 
            className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center shadow-lg hover:bg-blue-600 text-white transition-all active:scale-90"
            title="Call Us"
          >
            <Phone size={24} />
          </a>
        )}

        {/* Linktree Button */}
        {visibility.more && (
          <a 
            href="https://linktr.ee/click4ywnbusiness" 
            target="_blank" 
            rel="noreferrer" 
            className="w-12 h-12 bg-slate-100 dark:bg-slate-700 rounded-xl flex flex-col items-center justify-center shadow-md hover:bg-slate-200 dark:hover:bg-slate-600 text-slate-600 dark:text-slate-300 transition-all active:scale-95 border border-slate-200 dark:border-slate-600 group"
            title="More Links"
          >
            <MoreHorizontal size={18} className="group-hover:scale-110 transition-transform" />
            <span className="text-[9px] font-bold mt-1">More...</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default ContactCard;